import { take, flow } from 'lodash/fp';

import { GlobalToken } from 'antd';

import darkTheme from './dark-theme';
import lightTheme from './light-theme';

export type CustomThemeToken = GlobalToken & {
  [x: string]: any;
};

export const themes = {
  dark: darkTheme,
  light: lightTheme,
};
export const themeNames = Object.keys(themes);
export const storedThemeName = localStorage.getItem('theme') ?? themeNames[0];

export const getInvestigationDashboardChartColors = (token: CustomThemeToken) => [
  token.Ecoplant_Charts.colorLinechart_1,
  token.Ecoplant_Charts.colorLinechart_2,
  token.Ecoplant_Charts.colorLinechart_3,
  token.Ecoplant_Charts.colorLinechart_4,
  token.Ecoplant_Charts.colorLinechart_5,
  token.Ecoplant_Charts.colorLinechart_6,
  token.Ecoplant_Charts.colorLinechart_7,
  token.Ecoplant_Charts.colorLinechart_8,
  token.Ecoplant_Charts.colorLinechart_9,
  token.Ecoplant_Charts.colorLinechart_10,
];

export const getTrendsChartColors = flow(getInvestigationDashboardChartColors, take(4));

export const getLeakagePieChartColorPalette = (token: CustomThemeToken) => [
  [
    token.Ecoplant_Charts.colorOldProductionfloor,
    token.Ecoplant_Charts.colorOldProductionfloorWaist,
    token.Ecoplant_Charts.colorOldProductionfloorProduction,
  ],
  [
    token.Ecoplant_Charts.colorNewProductionfloor,
    token.Ecoplant_Charts.colorNewProductionfloorWaist,
    token.Ecoplant_Charts.colorNewProductionfloorProduction,
  ],
  [
    token.Ecoplant_Charts.colorSystemProductionfloor,
    token.Ecoplant_Charts.colorSystemProductionfloorWaist,
    token.Ecoplant_Charts.colorSystemProductionfloorProduction,
  ],
];

export const getStationStageColors = (token: CustomThemeToken) => [
  token.colorYellowText,
  token.colorAzureText,
  token.colorCyanText,
  token.colorVolcanoText,
  token.colorGeekBlueText,
  token.colorLimeText,
  token.colorMagentaText,
  token.colorPurpleText,
  token.colorInfoText,
  token.colorPrimaryText,
  token.colorErrorText,
];
